import { render, staticRenderFns } from "./date-of-birth.vue?vue&type=template&id=40997a99"
import script from "./date-of-birth.vue?vue&type=script&lang=js"
export * from "./date-of-birth.vue?vue&type=script&lang=js"
import style0 from "./date-of-birth.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports